import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '../../ff/services/authentication/authentication.service';
import { Router } from '@angular/router';
import { FFService } from '../../ff/ff.service';

@Component( {
  selector: 'ff-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.scss' ]
} )
export class LoginComponent {
  redirectDelay: number = 0; strategy: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  rememberMe = false;
  ff;

  constructor( protected service: AuthenticationService,
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private ff_service: FFService ) {
    this.ff = this.ff_service.ff;
    this.redirectDelay = 1000;
    // this.showMessages = this.getConfigValue('forms.login.showMessages');
    // this.rememberMe = this.getConfigValue('forms.login.rememberMe');
  }

  login (): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    // response is an observable from the login service.
    const response = this.service.login( this.user );

    if ( response ) {
      response.subscribe( {
        next: ( res: any ) => {
          // this.submitted = false;
          // this.messages.push('Authenticated successfully. Retrieving user information for authorization.');
          // console.log(JSON.stringify(res))

          // Ensure response is iterable.
          if ( !Array.isArray( res ) ) res = [ res ];

          // Let's see if we have any access tokens
          let access_token
          const access_tokens = res.filter( ( res_item ) => {
            return res_item.hasOwnProperty( 'mime_type' ) && res_item.mime_type === 'authorization/token';
          } );


          if ( access_tokens.length > 0 ) {
            access_token = access_tokens[ 0 ];
            sessionStorage.setItem( 'access_token', access_token.token );
          } else {
            // throw new Error( 'Failed to find authorization token in response from server.' );
          }
           
          // Get user data from access_control/account
          // access_control/account
          const user_data = res.filter( ( res_item ) => {
            return res_item.hasOwnProperty( 'mime_type' ) && res_item.mime_type === 'access_control/account';
          } );

          if ( user_data.length > 0 ) {
            // If we are given a user record or records, just use the first one.
            this.service.current_user_record = user_data[ 0 ];
            sessionStorage.setItem( 'current_user_data', JSON.stringify( user_data[ 0 ] ) );
          } else {
            // If we have an access token, try looking up the user profile from the access token
            this.service.get_user_profile( access_token._id ).subscribe( ( user_profile ) => {
              this.service.current_user_record = user_profile.msg;
              sessionStorage.setItem( 'current_user_data', JSON.stringify( user_profile.msg ) );
              // this.router.navigate(['/application/portal']);
            } );
          }

          // Get next action, which will be some response from the server on what to do
          // For now, we publish our actions to the application service, which is set up to handle things
          // The most common action is to navigate to something.
          //  If the server thinks you should use MFA, then it will redirect you to some MFA page for instance.
          const actions = res.filter( ( res_item ) => {
            return res_item.hasOwnProperty( 'mime_type' ) && res_item.mime_type === 'action/definition';
          } );
          if ( actions.length ) {
            // console.log(actions)
            this.ff.ff_service.publish( actions ).to( '/local/service/application' );
          }
        },

        // If the observable is some sort of error (i.e. things did not work right), handle it.
        // Note: Thses are not fancy errors, these are some sort of http error, so this is poorly coupled.
        // i.e. it expects our login returns either the res above or this error, which assumes http and is bad.
        error: ( err: any ) => {
          this.submitted = false;
          let remediation_instructions;
          let description;
          switch ( err.status ) {
            case 404:
              description = 'The authentication service is not responding.';
              remediation_instructions = 'Please send a request to RedWolf support.';
              break;
            case 401:
              description = 'The username or password you entered is incorrect.';
              remediation_instructions = 'Try again.';
              break;
            case 403:
              description = 'This user account is disabled.'
              remediation_instructions = 'Contact your account manager to have it enabled.';
              break;
            default:
              description = `The authentication service failed to respond.`;
              remediation_instructions = 'Send a request to RedWolf support.';
              break;
          }
          const ff_error = this.ff.fancy_data().error( {
            mime_type: 'notification/message',
            error: new Error( description ),
            remediation_instructions: remediation_instructions,
            severity: 'serious',
            title: `Login Failure`,
          } );
          this.ff.ff_service.publish( ff_error );
          this.errors.push( `${ ff_error.description } ${ remediation_instructions }` );
        },
      } );
    } else {
      this.submitted = false;
    }

    // this.service.getToken().subscribe((result: NbAuthResult) => {
    //   this.submitted = false;

    //   if (result.isSuccess()) {
    //     this.messages = result.getMessages();
    //   } else {
    //     this.errors = result.getErrors();
    //   }

    //   const redirect = result.getRedirect();
    //   if (redirect) {
    //     setTimeout(() => {
    //       return this.router.navigateByUrl(redirect);
    //     }, this.redirectDelay);
    //   }
    //   this.cd.detectChanges();
    // });
  }

}
